(function () {
  function initSliders() {
    if (typeof Flickity === 'undefined') {
      // Flickity script loaded with defer — retry until ready
      return window.setTimeout(initSliders, 50);
    }

    var sliders = document.querySelectorAll('[data-subcollection-slider]');
    sliders.forEach(function (el) {
      if (el.dataset.flickityInitialized === 'true') return;
      el.dataset.flickityInitialized = 'true';

      var flkty = new Flickity(el, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        groupCells: true,
        freeScroll: false,
        wrapAround: false,
        prevNextButtons: true,
        draggable: '>1'
      });

      // If all cells fit in the viewport (single page), destroy slider — static row instead
      if (flkty.slides && flkty.slides.length <= 1) {
        flkty.destroy();
        el.dataset.flickityInitialized = 'false';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }

  // Re-init when theme editor loads/reloads section
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.classList.contains('cc-subcollection-slider')) {
      initSliders();
    }
  });

  // Re-evaluate on resize (mobile <-> desktop cell width change)
  var resizeTimer;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      document.querySelectorAll('[data-subcollection-slider]').forEach(function (el) {
        if (el.dataset.flickityInitialized === 'true') {
          var flkty = Flickity.data(el);
          if (flkty) flkty.destroy();
        }
        el.dataset.flickityInitialized = 'false';
      });
      initSliders();
    }, 200);
  });
})();
